import React, { useState, useEffect } from 'react';
import dummyImage from "../img/company3.png";

const AuthenticatedImage = ({ 
  src, 
  alt, 
  style, 
  className,
  onError,
  fallbackSrc = dummyImage 
}) => {
  const [imageSrc, setImageSrc] = useState(fallbackSrc);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const loadImage = async () => {
      if (!src) {
        setImageSrc(fallbackSrc);
        setLoading(false);
        return;
      }

      // If it's already a full HTTP URL or local image, use it directly
      if (src.startsWith('http://') || src.startsWith('https://') || src.startsWith('/') || !src.includes('navodaya')) {
        setImageSrc(src);
        setLoading(false);
        return;
      }

      try {
        const token = localStorage.getItem("token");
        
        if (!token) {
          console.warn("No token found, using fallback image");
          setImageSrc(fallbackSrc);
          setLoading(false);
          return;
        }

        // Construct the full URL if it's just a filename
        let imageUrl = src;
        if (!src.startsWith('https://api.asterickx.com/')) {
          const cleanPath = src.startsWith('/') ? src.substring(1) : src;
          imageUrl = `https://api.asterickx.com/api/Assets/${cleanPath}`;
        }

        console.log("Fetching authenticated image:", imageUrl);

        const response = await fetch(imageUrl, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': '*/*'
          }
        });

        if (response.ok) {
          const blob = await response.blob();
          const imageObjectURL = URL.createObjectURL(blob);
          setImageSrc(imageObjectURL);
          setError(false);
        } else {
          console.warn("Failed to fetch image:", response.status, response.statusText);
          setImageSrc(fallbackSrc);
          setError(true);
        }
      } catch (err) {
        console.error("Error loading authenticated image:", err);
        setImageSrc(fallbackSrc);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    loadImage();

    // Cleanup function to revoke object URL
    return () => {
      if (imageSrc && imageSrc.startsWith('blob:')) {
        URL.revokeObjectURL(imageSrc);
      }
    };
  }, [src, fallbackSrc]);

  const handleError = (e) => {
    console.log("Image load error:", e.target.src);
    if (!error) {
      setImageSrc(fallbackSrc);
      setError(true);
    }
    if (onError) {
      onError(e);
    }
  };

  if (loading) {
    return (
      <div 
        style={{
          ...style,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f8f9fa',
          border: '2px dashed #dee2e6'
        }}
        className={className}
      >
        <span style={{ fontSize: '12px', color: '#6c757d' }}>Loading...</span>
      </div>
    );
  }

  return (
    <img
      src={imageSrc}
      alt={alt}
      style={style}
      className={className}
      onError={handleError}
    />
  );
};

export default AuthenticatedImage;